import type { JSX } from 'react';
import type { SurfaceOf } from './types';
import { useT } from '../i18n/useT';

export function MedicationListSurfaceView({ surface }: { surface: SurfaceOf<'medication-list'> }): JSX.Element {
  const t = useT();
  return (
    <section className="surface surface-meds">
      {surface.title ? <h3 className="surface-title">{surface.title}</h3> : null}
      {surface.medications.length === 0 ? (
        <p className="muted">{t('none')}</p>
      ) : (
        <ul className="med-list">
          {surface.medications.map((m) => (
            <li key={m.id} className={m.status.toLowerCase() === 'active' ? 'med med-active' : 'med'}>
              <div className="med-main">
                <strong>{m.name}</strong>
                <span>{[m.dose, m.route, m.frequency].filter(Boolean).join(' · ')}</span>
              </div>
              <div className="med-meta">
                <span className={`chip ${m.status.toLowerCase() === 'active' ? 'chip-good' : 'chip-muted'}`}>{m.status}</span>
                {m.startDate ? <span className="muted small">{m.startDate}</span> : null}
                <span className={m.provenance === 'ai-narrative' ? 'badge badge-ai' : 'badge'}>{m.provenance}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
